import React from "react";
import "../../App.scss";
import { Layout, Tooltip } from "antd";
import { HomeFilled } from "@ant-design/icons";
import cwclogo from "../../assets/cwc-logo.png";
import profile from "../../assets/profile.png";
import { useNavigate } from "react-router-dom";

const { Header } = Layout;

const Navbar = (props) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    const FrontendURL = `${window.location.protocol}//${window.location.hostname}`;
    const REDIRECT_URL =
      process.env.REACT_APP_ENV == "devlopment"
        ? `${FrontendURL}:3013`
        : `${FrontendURL}`;
    window.location.href = `${REDIRECT_URL}/login?clear=true`;
  };

  const redirectHome = () => {
    navigate("/cwc-support/dashboard");
  };

  const handleDashboardRedirect = async () => {
    const FrontendURL = `${window.location.protocol}//${window.location.hostname}`;
    const REDIRECT_URL =
      process.env.REACT_APP_ENV == "devlopment"
        ? `${FrontendURL}:3013`
        : `${FrontendURL}`;
    window.location.href = `${REDIRECT_URL}/module`;
  };

  return (
    <Layout>
      <Header style={{ background: "#f8f9fa" }} className="navbarContainer">
        <li style={{ cursor: "pointer" }} onClick={redirectHome}>
          <img src={cwclogo} alt="" />
        </li>
        <li>
          <span className="custom-heading" style={{fontWeight:"bolder"}}>
            {props?.heading || "Dashboard"}
          </span>
        </li>
        <div style={{ display: "flex", width: "5%", alignItems: "center" }}>
          <li>
            <Tooltip title="Back To Homepage">
              <div
                style={{ fontSize: 25, marginRight: 15, color: "black" }}
                onClick={handleDashboardRedirect}
              >
                <HomeFilled />
              </div>
            </Tooltip>
          </li>
          <li style={{ cursor: "pointer" }} onClick={handleLogout}>
            <img src={profile} alt="" />
          </li>
        </div>
      </Header>
    </Layout>
  );
};

export default Navbar;
